// _supabase-base.ts — resolve the Supabase edge-functions base URL.
//
// Shared by the schedule auth modules (oauth-web, token-manager) that call
// the Supabase oauth-exchange edge function. `window.SUPABASE_FUNCTIONS_URL`
// is the explicit override; otherwise we derive it from the Supabase project
// URL. That URL isn't injected on every host (bundled-config web builds ship
// only POWERSYNC_CONFIG, not SUPABASE_URL), so we fall back to the PowerSync
// config that carries the same project URL — present wherever sync is
// configured. Mirrors transport._relayBase.

/** @returns {string | null} the Supabase edge-functions base URL, or null. */
export function supabaseFunctionsBase(): string | null {
  if (typeof window === 'undefined') return null;
  if (window.SUPABASE_FUNCTIONS_URL) return window.SUPABASE_FUNCTIONS_URL;
  const supabaseUrl = window.SUPABASE_URL || (window.POWERSYNC_CONFIG as any)?.supabaseUrl;
  if (supabaseUrl) return `${supabaseUrl.replace(/\/$/, '')}/functions/v1`;
  return null;
}
